import { REGISTER_SINGLE_PAYMENT } from "..";
import { apiInstance } from "../config/apiInstance";

export type RegisterSinglePaymentRequest = {
  consecutive: string;
  electronicDocumentIds: number[];
  totalValue: number;
  budgetCertificate: string[];
  budgetRegistration: string[];
  paymentResolution: string;
  resolutionAttachmentId?: number;
  treasurySequence: string;
  paymentCategory: string;
  paymentAt: string;
  paymentAttachmentId: number;
};

export const registerSinglePayment = async (
  data: RegisterSinglePaymentRequest,
): Promise<void> => {
  await apiInstance.post(REGISTER_SINGLE_PAYMENT, data);
};
